import React, { useState, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Modal } from 'flowbite-react';
import Loading from './Loading';
import SuccessAlert from './SuccessAlert';

import MyAuthContext from "../context/AuthContext";


export const capitalize = (text) => {

    text = text.replace(/\s+/g, ' ');

    let text1 = text.toLowerCase();
    const arr = text1.split(" ");
    //loop through each element of the array and capitalize the first letter.

    //loop through each element of the array and capitalize the first letter.

    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    //Join all the elements of the array back into a string 
    //using a blankspace as a separator 
    const str2 = arr.join(" ");
    return str2
}

export const style = {
    formInput: "block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none  focus:outline-none focus:ring-0 focus:border-teal-500 peer",
    formLabel: "peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-2 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-teal-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
}


export const ErrorWrapper = ({error})=> 
     (
        <div class="  text-xs text-red-700 rounded-lg dark:bg-gray-800 dark:text-red-400" role="alert">
        <span class="font-normal "> {error}</span> 
        </div>
    );


const ModalSignUp = ({ isModalSignUpOpen, setIsModalSignUpOpen, setSuccessAlert, setIsModalLogInOpen}) => {

    const { registerUser, loading, error, setError } = useContext(MyAuthContext);

    const actualDate = () => {
        const date = new Date().toLocaleDateString('sv-SE')
        return date
    }

    const [shownPassword, setShownPassword] = useState(false);
    const [shownConfirmPassword, setShownConfirmPassword] = useState(false);

    const switchShownPassword = () => setShownPassword(!shownPassword)
    const switchConfirmShownPassword = () => setShownConfirmPassword(!shownConfirmPassword)

    const schema = yup.object().shape({
        userName: yup.string().required("El nombre es requerido").matches(/^[a-zA-Z ]+$/, "El nombre no debe contener caracteres especiales").max(30, "Nombre demasiado largo").min(1).trim().transform((currentValue) => capitalize(currentValue)),
        userLastName: yup.string().required("El apellido es requerido").matches(/^[a-zA-Z ]+$/, "El apellido no debe contener caracteres especiales").max(30, "Apellido demasiado largo").min(1).trim().transform((currentValue) => capitalize(currentValue)),
        documentTypeId: yup.string()
            .oneOf(["1", "2", "3",], "Debes elegir un tipo de identificacion"),
        userDocumentNumber: yup.string().required("El numero de identificacion es requerido").min(8, "El numero de identificacion es invalido").max(10),
        userDocumentExpeditionDate: yup.string().required("Fecha de expedicion requerida").test(dateString => new Date(dateString).toString() !== 'Invalid Date').test({ message: "Fecha invalida", test: dateString => new Date(dateString) < new Date }),
        userEmail: yup.string().email("Debe ser un correo válido").required("El correo es requerido"),
        userPhone: yup.string().required("El numero de telefono es requerido ").min(8, "El numero de telefono es invalido").max(10),
        userPassword: yup.string().required("La contraseña es requerida").min(8, "La contraseña debe tener al menos 8 caracteres").matches(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@$!%*?&#.])[A-Za-z0-9@$!%*?&#.]+$/, "La contraseña debe contener 1 mayuscula, 1 miniscula, 1 numero y uno de los siguientes caracteres: @$!%*?&#.").max(24, "Contraseña demasiado larga"),
        confirmUserPassword: yup.string().oneOf([yup.ref("userPassword")], "Las contraseñas no coinciden").required(""),
        acceptTerms: yup.boolean().oneOf([true],"Debe aceptar los términos y condiciones")
    })

    const { handleSubmit, control, register, reset, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        const res = await registerUser(data)
        if (res.error) {
            setError({ "error": true, "message": res.response })
            setTimeout(() => {
                setError({ "error": false, "message": "" })
            }, 5000);
        } else {
            setSuccessAlert("Revise su correo para activar la cuenta")
            reset()
            setError({ "error": false, "message": "" })
            setIsModalSignUpOpen(false)
            setIsModalLogInOpen(true)
            setTimeout(() => {
                setSuccessAlert(null)

            }, 5000);
        }
    }

    const closeModal = () => {
        setIsModalSignUpOpen(false)
        reset()
    }

    return (
        <>

            <Modal show={isModalSignUpOpen} style={{height:"100%" }} position="center" onClose={reset}>
                <div class="flex flex-col items-center justify-center mx-auto">
                    <div className='w-full bg-white rounded-lg shadow'>
                        <div class="p-6 space-y-4">
                            <div class="flex flex-row pt-3">
                                <h1 class="text-xl font-bold leading-tight tracking-tight  md:text-2xl">Crear Cuenta</h1>
                                <button className='absolute font-bold top-2 right-3' onClick={() => closeModal()}>x</button>
                            </div>
                            <p class='text-sm font-light text-gray-500'>En los campos señalados con * es obligatorio ingresar la informacion solicitada.</p>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div class="grid grid-cols-2 gap-6">
                                    <div class="mb-6 ">
                                        <div class="relative z-0 w-full group">
                                            <input type="text" {...register("userName")} class={style.formInput} placeholder=" " />
                                            <label class={style.formLabel}>Nombres*</label>
                                        </div>
                                        <ErrorWrapper error={errors.userName?.message} />
                                    </div>
                                    <div class="relative z-0 mb-6 w-full group">
                                        <input type="text" {...register("userLastName")} class={style.formInput} placeholder=" " />
                                        <label class={style.formLabel}>Apellidos*</label>
                                        <ErrorWrapper error={errors.userLastName?.message} />
                                    </div>
                                </div>

                                <div class="grid sm:grid-cols-3 sm:gap-6">
                                    <div class="relative z-0 mb-6 w-full group">
                                        <select {...register("documentTypeId")} class={style.formInput}>
                                            <option value="">Seleccionar...</option>
                                            <option value="1">Cédula de Ciudadanía</option>
                                            <option value="2">Cédula de Extranjería</option>
                                            <option value="3">Pasaporte</option>
                                        </select>
                                        <label class={style.formLabel}>Tipo de Documento*</label>
                                        <ErrorWrapper error={errors.documentTypeId?.message} />
                                    </div>
                                    <div class="relative z-0 mb-6 w-full group">
                                        <Controller
                                            name="userDocumentNumber"
                                            control={control}
                                            defaultValue=""
                                            render={({ field: { value, onChange, ...field } }) => (
                                                <input type="text" pattern="[0-9]{0,10}" class={style.formInput} placeholder=" "
                                                    {...field}
                                                    onChange={({ target: { value, validity } }) => {
                                                        const isValid = validity.valid
                                                        if (isValid) {
                                                            onChange(value);
                                                        }
                                                    }
                                                    }
                                                    value={value}
                                                />
                                            )}
                                        />
                                        <label class={style.formLabel}>Numero de Documento*</label>
                                        <ErrorWrapper error={errors.userDocumentNumber?.message} />
                                    </div>
                                    <div class="relative z-0 mb-6 w-full group">
                                        <input type="date" min="1920-01-01" max={actualDate()} {...register("userDocumentExpeditionDate")} class={style.formInput} placeholder=" " />
                                        <label class={style.formLabel}>Fecha de Expedición*</label>
                                        <ErrorWrapper error={errors.userDocumentExpeditionDate?.message} />


                                    </div>

                                </div>



                                <div class="grid grid-cols-2 gap-6">
                                    <div class="relative z-0 mb-6 w-full group">
                                        <input type="email" {...register("userEmail")} class={style.formInput} placeholder=" " />
                                        <label class={style.formLabel}>Correo Electronico*</label>
                                        <ErrorWrapper error={errors.userEmail?.message} />
                                    </div>
                                    <div class="relative z-0 mb-6 w-full group">
                                        <Controller
                                            name="userPhone"
                                            control={control}
                                            defaultValue=""
                                            render={({ field: { value, onChange, ...field } }) => (
                                                <input type="tel" pattern="[0-9]{0,10}" class={style.formInput} placeholder=" "
                                                    {...field}
                                                    onChange={({ target: { value, validity } }) => {
                                                        const isValid = validity.valid
                                                        if (isValid) {
                                                            onChange(value);
                                                        }
                                                    }
                                                    }
                                                    value={value}
                                                />
                                            )}
                                        />
                                        <label class={style.formLabel}>Telefono de Contacto*</label>
                                        <ErrorWrapper error={errors.userPhone?.message} />
                                    </div>
                                </div>

                                <div class="grid grid-cols-2 gap-6 ">
                                    <div class="mb-6 ">
                                        <div class="relative z-0  w-full group">
                                            <input type={shownPassword ? 'text' : 'password'} {...register("userPassword")} class={style.formInput} placeholder=" " />
                                            <button class="absolute transform  translate-y-[-50%] top-[50%] right-3" type="button" onClick={switchShownPassword}>
                                                {shownPassword ? <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg> : <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"></path></svg>}
                                            </button>
                                            <label class={style.formLabel}>Contraseña*</label>

                                        </div>
                                        <ErrorWrapper error={errors.userPassword?.message} />
                                    </div>
                                    <div class="mb-6 ">
                                        <div class="relative z-0 w-full group">
                                            <input type={shownConfirmPassword ? 'text' : 'password'} {...register("confirmUserPassword")} class={style.formInput} placeholder=" " />
                                            <button class="absolute transform  translate-y-[-50%] top-[50%] right-3" type="button" onClick={switchConfirmShownPassword}>
                                                {shownConfirmPassword ? <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg> : <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"></path></svg>}
                                            </button>
                                            <label class={style.formLabel}>Confirmar Contraseña*</label>
                                        </div>
                                        <ErrorWrapper error={errors.confirmUserPassword?.message} />
                                    </div>
                                </div>

                                <div class="flex items-center">
                                    <input type="checkbox" {...register("acceptTerms")} class="w-4 h-4 text-teal-500 bg-gray-100 rounded border-gray-300 focus:outline-none focus:ring-0 focus:border-teal-500 peer"></input>
                                    <label class="ml-2 mb-2 text-sm font-light text-gray-500">Acepto terminos y condiciones y autorizo el tratamiento de mis datos personales de acuerdo con la <a target="_blank" href="https://www.alcaldianeiva.gov.co/Paginas/Politicas-de-Privacidad-y-Condiciones-de-Uso.aspx" class="text-teal-500 hover:underline">Politica de Privacidad, Tratamiento de datos personales y Condiciones de uso</a>.</label>
                                </div>
                                <ErrorWrapper error={errors.acceptTerms?.message} />
                                <div className='text-center w-full mb-5'>
                                    {error.error && <ErrorWrapper error={error.message} />}
                                </div>
                                {loading ? <Loading isLoading={loading}/>: <button type="submit" class="flex mx-auto bg-gray-300 border shadow hover:text-white hover:bg-teal-400 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm w-full w-auto px-5 py-2.5 text-center">Crear Cuenta</button>}
                                

                            </form>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default ModalSignUp;